import React from "react";
import "../css/InputField.css";
const InputField = ({
  label,
  type = "text",
  value,
  name,
  onChange,
  placeholder,
  min,
  readOnly,
}) => (
  <div className="input-label">
    <label>{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      className="input-field"
      min ={min}
      placeholder={placeholder}
      required
    />
  </div>
);

export default InputField;
